export default __webpack_public_path__ + "static/media/wall3D.87e5fc19.jpg";